<template>
  <div class="container">
    <sidebar class="sidebar-container" />
    <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="key" />
      </transition>
    </section>
  </div>
</template>

<script>
import { Sidebar } from "./components";
export default {
  name: "LayoutBack",
  components: { Sidebar },
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
// @import "~@/styles/variables.scss";
.container {
  position: relative;
  padding-left: 210px;
  flex: 1;
  .sidebar-container {
    -webkit-transition: width .28s;
    transition: width .28s;
    width: 210px!important;
    background-color: #304156;
    position: absolute;
    font-size: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
  }
}
</style>